import { useStaticQuery, graphql } from 'gatsby';

const useCoachData = () => {
  const { dataYaml: data } = useStaticQuery(
    graphql`
      query CoachData {
        dataYaml {
          profiles {
            slug
            name
            website
            video
            bio
            certifications {
              name
            }
            workwithme {
              worktype
            }
            linkedin
            twitter
            facebook
            instagram
            intake
          }
        }
      }
    `
  );
  return data;
};

export default useCoachData;
